// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
    padding: 20px 20px;
    font-size: 1.6rem;
    font-weight: bold;
    text-align: left;
    color: #222;
    font-family: "Segoe UI", sans-serif;
}

.header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center;            
  padding: 20px 20px;            
}

.oee-dashboard {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    padding: 25px;
    background-color: #f4f5f7;
    justify-content: flex-start;
}

.oee-tile {
    width: 200px;
    height: 150px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
    font-family: "Segoe UI", sans-serif;
    padding: 8px;
}

.oee-tile:hover {
    transform: scale(1.03);
}

.tile-running {
    background-color: #009e2f;
}

.tile-idle {
    background-color: #efa330;
    color: #ffffff;
}

.tile-alarm {
    background-color: #ff5722;
}

.tile-disconnect {
    background-color: #9e9e9e;
}

.machine-name {
    font-size: clamp(0.8rem, 1.2vw, 1rem);
    font-weight: 700;
    margin-bottom: 2px;
}

.status-text {
    font-size: 0.7rem;
    font-weight: 600;
    opacity: 0.9;
}

.oee-value {
    font-size: 1.9rem;
    font-weight: 800;
    margin: 5px 0;
    line-height: 1;
}

.cycle-status {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    opacity: 0.9;
}

.program-number {
    font-size: 0.7rem;
    font-weight: 500;
    margin-top: 4px;
    opacity: 0.95;
}

.iframe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 25px;
  margin-bottom: 10px;
}

.iframe-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
}

.operation-name {
  font-size: 1rem;
  font-weight: 500;
  color: #666;
  font-style: italic;
  text-align: right;
}


@media (min-width: 1440px) {
    .machine-name {
        font-size: 1.2rem !important;
    }
}

.selected-tile {
  border: 3px solid #939495;
  box-shadow: 0 0 10px rgba(75, 76, 77, 0.4);
}



`, "",{"version":3,"sources":["webpack://./src/app/Pages/CycleTime/inprogressoee.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mCAAmC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,gCAAgC;IAChC,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C","sourcesContent":[".heading {\n    padding: 20px 20px;\n    font-size: 1.6rem;\n    font-weight: bold;\n    text-align: left;\n    color: #222;\n    font-family: \"Segoe UI\", sans-serif;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between; \n  align-items: center;            \n  padding: 20px 20px;            \n}\n\n.oee-dashboard {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 18px;\n    padding: 25px;\n    background-color: #f4f5f7;\n    justify-content: flex-start;\n}\n\n.oee-tile {\n    width: 200px;\n    height: 150px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-align: center;\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n    transition: all 0.2s ease-in-out;\n    font-family: \"Segoe UI\", sans-serif;\n    padding: 8px;\n}\n\n.oee-tile:hover {\n    transform: scale(1.03);\n}\n\n.tile-running {\n    background-color: #009e2f;\n}\n\n.tile-idle {\n    background-color: #efa330;\n    color: #ffffff;\n}\n\n.tile-alarm {\n    background-color: #ff5722;\n}\n\n.tile-disconnect {\n    background-color: #9e9e9e;\n}\n\n.machine-name {\n    font-size: clamp(0.8rem, 1.2vw, 1rem);\n    font-weight: 700;\n    margin-bottom: 2px;\n}\n\n.status-text {\n    font-size: 0.7rem;\n    font-weight: 600;\n    opacity: 0.9;\n}\n\n.oee-value {\n    font-size: 1.9rem;\n    font-weight: 800;\n    margin: 5px 0;\n    line-height: 1;\n}\n\n.cycle-status {\n    font-size: 0.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    opacity: 0.9;\n}\n\n.program-number {\n    font-size: 0.7rem;\n    font-weight: 500;\n    margin-top: 4px;\n    opacity: 0.95;\n}\n\n.iframe-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 25px;\n  margin-bottom: 10px;\n}\n\n.iframe-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.operation-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #666;\n  font-style: italic;\n  text-align: right;\n}\n\n\n@media (min-width: 1440px) {\n    .machine-name {\n        font-size: 1.2rem !important;\n    }\n}\n\n.selected-tile {\n  border: 3px solid #939495;\n  box-shadow: 0 0 10px rgba(75, 76, 77, 0.4);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
